import { render, staticRenderFns } from "./informationDetail.vue?vue&type=template&id=de6a1230&scoped=true&"
import script from "./informationDetail.vue?vue&type=script&lang=js&"
export * from "./informationDetail.vue?vue&type=script&lang=js&"
import style0 from "./informationDetail.vue?vue&type=style&index=0&id=de6a1230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6a1230",
  null
  
)

export default component.exports